(function () {
    'use strict';

    angular
        .module('app.campaignInfluencersManagePage', [])
        .factory('campaignInfluencersManagePageService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function handleRequest(url, method, params, loader, isGetTotalCount) {
                    var deferred = $q.defer();
                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader,
                        isGetTotalCount: isGetTotalCount
                    }

                    $http(req).success(function (response) {
                        deferred.resolve(response);
                    }).error(function (error) {
                        deferred.reject(error);
                    });

                    return deferred.promise;
                }

                function getCampaignList(pageIndex, pageSize, loader) {
                    var url_campaignInfluencers = $rootScope.apiUrl
                        + 'campaign/getCampaignsForInfluencer?'
                        + 'influencer_id=' + $rootScope.influencerInformation.id + '&page=' + pageIndex + '&page_size=' + pageSize;
                    return handleRequest(url_campaignInfluencers, 'GET', null, loader);
                }

                function getNumberOfCampaignsForInfluencer() {
                    var url_numberOfCampaignInfluencers = $rootScope.apiUrl
                        + 'campaign/getNumberOfCampaignsForInfluencer?' + 'influencer_id=' + $rootScope.influencerInformation.id;
                    return handleRequest(url_numberOfCampaignInfluencers, 'GET', null, false, true);
                }

                function acceptCampaign(params, loader) {
                    var url_acceptCampaign = $rootScope.apiUrl + 'campaign/acceptCampaign';
                    return handleRequest(url_acceptCampaign, 'POST', params, loader);
                }

                function rejectCampaign(params, loader) {
                    var url_rejectCampaign = $rootScope.apiUrl + 'campaign/rejectCampaign';
                    return handleRequest(url_rejectCampaign, 'POST', params, loader);
                }

                function saveImg(params) {
                    var url_saveImg = $rootScope.apiUrl + 'campaign/saveImg';
                    return handleRequest(url_saveImg, 'POST', params);
                }

                service.getCampaignList = getCampaignList;
                service.getNumberOfCampaignsForInfluencer = getNumberOfCampaignsForInfluencer;
                service.acceptCampaign = acceptCampaign;
                service.rejectCampaign = rejectCampaign;
                service.saveImg = saveImg;

                return service;
            }
        ])
        .directive('bootstrapPopover', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    element.popover({
                        content: 'Data Feed is NOT setup. Please setup before publishing any campaign posts.</br></br>Please authorize your channel in Settings:</br><button class="btn-popover">SETTINGS</button>',
                        html: true,
                        placement: 'bottom',
                        trigger: "manual",
                        animation: false
                    })
                        .on("mouseenter", function () {
                            var _this = this;
                            $(this).popover("show");
                            $(".popover").on("mouseleave", function () {
                                $(_this).popover('hide');
                            });
                        })
                        .on("mouseleave", function () {
                            var _this = this;
                            setTimeout(function () {
                                if (!$(".popover:hover").length) {
                                    $(_this).popover("hide");
                                }
                            }, 300);
                        })
                }
            };
        })
})();
